import { createAction } from "@reduxjs/toolkit";

// 2026-10-06 · «Te han quitado la mesa en la que estabas» (lease tomado por
// otro dispositivo). Lo despacha MesaLeaseBridge SOLO cuando la mesa revocada
// es la que este dispositivo tenía abierta. Es la única señal para cerrar todo
// lo que colgaba de esa mesa:
//   - diálogos con estado en Redux → los slices escuchan esta acción
//     (product: complementos/notas y el producto a medio configurar;
//      mesas: comensales);
//   - diálogos con estado local → hook `useOnMesaKicked`.
// Acción aparte (y no un reducer de mesaLeases) para que product/mesas puedan
// escucharla sin importarse entre slices.
export const mesaKicked = createAction("mesaLeases/mesaKicked", (mesaId) => ({
  payload: { mesaId: mesaId ?? null, ts: Date.now() },
}));
